import { NzTableComponent } from 'ng-zorro-antd/table';
import { SimpleChanges, SimpleChange } from '@angular/core';

export function setTableData(table: NzTableComponent, data: any) {
    table.nzData = data;
    const changes: SimpleChanges={
        nzData: new SimpleChange(table.nzData, data, false)
    }
    table.ngOnChanges(changes);

}